<template>
    <v-card class="mb-1">
        <v-card-title class="card-title">
            Transcriptomic Vulnerabilities
        </v-card-title>
    </v-card>
</template>

<script>
    export default {
        name: "TransEvidence"
    }
</script>

<style scoped lang="sass">
    .card-title
        font-family: Raleway
        color: #888
        padding-bottom: 5px
</style>